import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
import { CTAButton } from './ui/CTAButton';
import { ShieldCheckIcon, LockIcon, CreditCardIcon, ZapIcon } from 'lucide-react';
export function FinalCTASection() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(24);
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  const megaPackUrl = 'https://checkout.guiadigital360.online/cart/43889650401349:1';
  const aceleradorUrl = 'https://checkout.guiadigital360.online/cart/44773397397573:1';
  return <section className="py-24 px-4 bg-brand-dark text-white text-center" data-id="element-80">
      <div className="max-w-4xl mx-auto" data-id="element-81">
        <div className="inline-block bg-white/10 text-white font-bold px-6 py-2 rounded-full mb-8 border border-white/20" data-id="element-82">
          🔥 ARSENAL DEL SOLDADOR 24HS
        </div>

        <h2 className="text-3xl md:text-5xl font-black mb-8 leading-tight" data-id="element-83">
          Podés seguir mirando videos sin empezar.
          <br data-id="element-84" />
          <span className="text-brand-amber" data-id="element-85">
            O podés tener el sistema completo desde hoy.
          </span>
        </h2>

        <div className="bg-[#292524] p-8 rounded-3xl border border-gray-700 mb-12" data-id="element-86">
          <p className="text-xl font-bold text-gray-300 mb-4" data-id="element-87">
            ⏰ El precio promocional cierra en:
          </p>
          <div className="flex justify-center gap-4 mb-6" data-id="element-88">
            <div className="text-4xl md:text-5xl font-black text-brand-amber" data-id="element-89">
              {formatTime(hours)}
              <span className="text-sm text-gray-400 ml-1" data-id="element-90">hs</span>
            </div>
            <div className="text-4xl md:text-5xl font-black text-gray-500" data-id="element-91">
              :
            </div>
            <div className="text-4xl md:text-5xl font-black text-brand-amber" data-id="element-92">
              {formatTime(minutes)}
              <span className="text-sm text-gray-400 ml-1" data-id="element-93">min</span>
            </div>
            <div className="text-4xl md:text-5xl font-black text-gray-500" data-id="element-94">
              :
            </div>
            <div className="text-4xl md:text-5xl font-black text-brand-amber" data-id="element-95">
              {formatTime(seconds)}
              <span className="text-sm text-gray-400 ml-1" data-id="element-96">seg</span>
            </div>
          </div>
          <p className="text-red-400 font-bold" data-id="element-97">
            Después vuelve a $49.900 ARS.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto mb-12" data-id="element-98">
          {/* Mega Pack */}
          <div className="bg-[#292524] p-6 rounded-2xl border border-gray-700 flex flex-col justify-between" data-id="element-99">
            <div data-id="element-100">
              <h3 className="text-xl font-bold mb-2" data-id="element-101">📘 MEGA PACK COMPLETO</h3>
              <p className="text-sm text-gray-400 mb-4" data-id="element-102">5 Tomos + 3 Bonos</p>
            </div>
            <div data-id="element-103">
              <div className="text-2xl font-black text-white mb-4" data-id="element-104">
                $19.990 pesos
              </div>
              <CTAButton text="→ QUIERO EL MEGA PACK" href={megaPackUrl} isLink={true} className="text-sm py-3" data-id="element-105" />
            </div>
          </div>

          {/* Highlighted Pack */}
          <div className="bg-white text-brand-dark p-6 rounded-2xl shadow-2xl border-4 border-brand-amber relative flex flex-col justify-between" data-id="element-106">
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-brand-amber text-white font-black px-4 py-1 rounded-full text-xs whitespace-nowrap" data-id="element-107">
              ⭐ MÁS ELEGIDO
            </div>
            <div data-id="element-108">
              <h3 className="text-xl font-black flex items-center gap-2 mb-2" data-id="element-109">
                ⚡ MEGA PACK + ACELERADOR
              </h3>
              <p className="text-sm text-gray-600 mb-4 font-medium" data-id="element-110">
                Todo el Mega Pack + El mapa exacto de 30 días
              </p>
            </div>
            <div data-id="element-111">
              <div className="text-3xl font-black text-brand-amber mb-4" data-id="element-112">
                $24.990 pesos
              </div>
              <CTAButton text="→ QUIERO EL ACELERADOR" href={aceleradorUrl} isLink={true} className="text-sm py-3" data-id="element-113" />
            </div>
          </div>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-6 text-sm text-gray-400 font-medium" data-id="element-114">
          <span className="flex items-center gap-2" data-id="element-115">
            <LockIcon className="w-5 h-5" data-id="element-116" /> Pago 100% seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-117">
            <ZapIcon className="w-5 h-5 text-brand-forge" data-id="element-118" /> Acceso en 5 minutos
          </span>
          <span className="flex items-center gap-2" data-id="element-119">
            <ShieldCheckIcon className="w-5 h-5 text-brand-green" data-id="element-120" /> Garantía 7
            días sin preguntas
          </span>
          <span className="flex items-center gap-2" data-id="element-121">
            <CreditCardIcon className="w-5 h-5" data-id="element-122" /> Mercado Pago | Tarjeta |
            Transferencia
          </span>
        </div>
      </div>
    </section>;
}